'use client';

import {Fragment} from 'react';
import {useMediaQuery, useTheme} from '@mui/material';
import CtaCard from './CtaCard';
import CtaItem from './CtaItem';
import {
  StyledCtaCardsContainer,
  StyledCtaItemsContainer,
} from '@/components/sections/cta-cards-section/CtaCardSection.styles';
import {ModalSectionItem} from '@/lib/ensure-link-button';

export type CtaCardVariant = 'v1' | 'v2';

export type CtaCardListItem = {
  id: string;
  heading: string;
  imageUrl: string;
  href: string;
  isExternal: boolean;
  modalSections?: ReadonlyArray<ModalSectionItem | null> | null;
  breadText?: string | null;
  focalX?: number | null;
  focalY?: number | null;
  variant: CtaCardVariant;
  skipGradient?: boolean | null;
};

type CtaCardListProps = {
  cards: CtaCardListItem[];
};

export default function CtaCardList({cards}: CtaCardListProps) {
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'));

  if (isSmall) {
    return (
      <StyledCtaItemsContainer>
        {cards.map((card) => (
          <Fragment key={card.id}>
            <CtaItem
              heading={card.heading}
              imageUrl={card.imageUrl}
              href={card.href}
              isExternal={card.isExternal}
              modalSections={card.modalSections}
              breadText={card.breadText ?? undefined}
              focalX={card.focalX}
              focalY={card.focalY}
              contentId={card.id}
            />
          </Fragment>
        ))}
      </StyledCtaItemsContainer>
    );
  }

  return (
    <StyledCtaCardsContainer>
      {cards.map((card) => (
        <Fragment key={card.id}>
          <CtaCard
            heading={card.heading}
            imageUrl={card.imageUrl}
            href={card.href}
            isExternal={card.isExternal}
            modalSections={card.modalSections}
            breadText={card.breadText ?? undefined}
            focalX={card.focalX}
            focalY={card.focalY}
            contentId={card.id}
            variant={card.variant}
            skipGradient={card.skipGradient ?? false}
          />
        </Fragment>
      ))}
    </StyledCtaCardsContainer>
  );
}
